var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8"},[_c('campaign-form',{attrs:{"campaign":this.campaign,"title":"Editar campaña"},on:{"submit":_vm.saveCampaign}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }